/**
 * Get the error type for the table fetch
 * @param {Object} error - The error object
 * @returns {Object} The error types
 */
const getTableFetchError = (error) => {
    const errorTypes = {
        isTimeoutApiGateway: false,
        isTimeoutALB: false,
        isBadGateway: false
    };

    // If no error, return all error types as false
    if (!error) {
        return errorTypes;
    }
    // If the error is a timeout, return IsTimeout as true
    if ((error.code && error.code === 'ECONNABORTED')
        || (error.response && error.response.data && error.response.data.message === 'Endpoint request timed out')) {
        return { ...errorTypes, isTimeoutApiGateway: true };
    }
    // If the error is a timeout ALB, return IsTimeoutALB as true
    if (error.response && error.response.data && error.response.data.errorCode === 'TIMEOUT') {
        return { ...errorTypes, isTimeoutALB: true };
    }
    // If the error is a bad gateway, return IsBadGateway as true
    if (error.response && error.response.data && error.response.data.errorCode === 'BAD_GATEWAY') {
        return { ...errorTypes, isBadGateway: true };
    }

    return errorTypes;
};

export default getTableFetchError;